import React from 'react';
import './ComparisonSection.css';

const ComparisonSection = () => {
    const otherSolutions = [
        { text: 'Generic recommendations', desc: 'One-size-fits-all solutions that ignore your unique symptoms' },
        { text: 'Overwhelming options', desc: 'Hundreds of products with no clear guidance' },
        { text: 'Trial and error', desc: 'Wasted time and money on products that don\'t work' },
        { text: 'No personalization', desc: 'Generic advice that doesn\'t consider your lifestyle' },
    ];

    const menoMatch = [
        { text: 'Personalized matching', desc: 'Recommendations tailored to YOUR specific symptoms' },
        { text: 'Curated top 3 picks', desc: 'Only the best options, carefully selected for you' },
        { text: 'Science-backed results', desc: 'Every recommendation backed by clinical research' },
        { text: '2-minute quiz', desc: 'Quick, easy, and completely free assessment' },
    ];

    return (
        <section className="comparison-section">
            <div className="container">
                <div className="comparison-header">
                    <span className="section-badge">Why Choose Us</span>
                    <h2 className="section-title">
                        Expert recommendations tailored to
                        <span className="gradient-text"> your wellness</span>
                    </h2>
                </div>

                <div className="comparison-grid">
                    {/* Other Solutions */}
                    <div className="comparison-card comparison-others">
                        <h3 className="comparison-card-title">Other Solutions</h3>
                        <ul className="comparison-list">
                            {otherSolutions.map((item, index) => (
                                <li key={index} className="comparison-item">
                                    <div className="comparison-icon comparison-icon-x">
                                        <svg viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <div className="comparison-text">
                                        <strong>{item.text}</strong>
                                        <span>{item.desc}</span>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* MenoMatch */}
                    <div className="comparison-card comparison-menomatch">
                        <h3 className="comparison-card-title">With MenoMatch</h3>
                        <ul className="comparison-list">
                            {menoMatch.map((item, index) => (
                                <li key={index} className="comparison-item">
                                    <div className="comparison-icon comparison-icon-check">
                                        <svg viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <div className="comparison-text">
                                        <strong>{item.text}</strong>
                                        <span>{item.desc}</span>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ComparisonSection;
